
export const convertDate = (data) => {

  if (data == '' || data == null || data == undefined) {
    data = new Date()
  }
  else if(data.lenght === 10){
    let datasplited = data.split('-');
    let datasplited2 = datasplited[2].split(' ');

    data = datasplited2[0] + '/' + datasplited[1] + '/' + datasplited[0]
  }else{
    return(data)
  }
  return data;
}
